<template>
  <section>
    <div class="main-container">
      <div class="image-container " @click="linkTo('calendario-semanal')">
        <div class="image-clip">
          <img class="desktop" src="@/assets/SlidePrincipal2.webp" alt="Imagen Principal" />
          <img class="mobile" src="@/assets/SlidePrincipal2.webp" alt="Imagen Principal" />
        </div>
        <div class="text-overlay">
          <svg xmlns="http://www.w3.org/2000/svg" width="52" height="42" viewBox="0 0 52 42" fill="none"
            class="calendar-svg mobile">
            <path
              d="M49.2174 42H0.387853C0.17398 42 0 41.825 0 41.6099V3.35938C0 3.14426 0.17398 2.96927 0.387853 2.96927H49.2174C49.4313 2.96927 49.6053 3.14426 49.6053 3.35938V24.142C49.6053 24.3571 49.4313 24.5321 49.2174 24.5321C49.0036 24.5321 48.8296 24.3571 48.8296 24.142V3.74948H0.775706V41.2209H48.8296V38.7175C48.8296 38.5024 49.0036 38.3274 49.2174 38.3274C49.4313 38.3274 49.6053 38.5024 49.6053 38.7175V41.611C49.6053 41.8261 49.4313 42 49.2174 42Z"
              fill="#464D5B" />
            <path
              d="M10.9508 6.71875C10.7369 6.71875 10.5629 6.54376 10.5629 6.32864C10.5629 6.11353 10.7369 5.93854 10.9508 5.93854C12.3648 5.93854 13.515 4.78159 13.515 3.35938C13.515 1.93716 12.3648 0.780213 10.9508 0.780213C9.53675 0.780213 8.38649 1.93716 8.38649 3.35938C8.38649 3.57449 8.21251 3.74948 7.99864 3.74948C7.78476 3.74948 7.61078 3.57449 7.61078 3.35938C7.61078 1.50693 9.109 0 10.9508 0C12.7925 0 14.2907 1.50693 14.2907 3.35938C14.2907 5.21183 12.7925 6.71875 10.9508 6.71875Z"
              fill="#464D5B" />
            <path
              d="M20.1861 6.71875C19.9722 6.71875 19.7982 6.54376 19.7982 6.32864C19.7982 6.11353 19.9722 5.93854 20.1861 5.93854C21.6001 5.93854 22.7503 4.78159 22.7503 3.35938C22.7503 1.93716 21.6001 0.780213 20.1861 0.780213C18.7721 0.780213 17.6218 1.93716 17.6218 3.35938C17.6218 3.57449 17.4478 3.74948 17.234 3.74948C17.0201 3.74948 16.8461 3.57449 16.8461 3.35938C16.8461 1.50693 18.3443 0 20.1861 0C22.0278 0 23.5261 1.50693 23.5261 3.35938C23.5261 5.21183 22.0278 6.71875 20.1861 6.71875Z"
              fill="#464D5B" />
            <path
              d="M29.4203 6.71875C29.2064 6.71875 29.0325 6.54376 29.0325 6.32864C29.0325 6.11353 29.2064 5.93854 29.4203 5.93854C30.8343 5.93854 31.9846 4.78159 31.9846 3.35938C31.9846 1.93716 30.8343 0.780213 29.4203 0.780213C28.0063 0.780213 26.856 1.93716 26.856 3.35938C26.856 3.57449 26.6821 3.74948 26.4682 3.74948C26.2543 3.74948 26.0803 3.57449 26.0803 3.35938C26.0803 1.50693 27.5786 0 29.4203 0C31.2621 0 32.7603 1.50693 32.7603 3.35938C32.7603 5.21183 31.2621 6.71875 29.4203 6.71875Z"
              fill="#464D5B" />
            <path
              d="M38.6556 6.71875C38.4418 6.71875 38.2678 6.54376 38.2678 6.32864C38.2678 6.11353 38.4418 5.93854 38.6556 5.93854C40.0696 5.93854 41.2199 4.78159 41.2199 3.35938C41.2199 1.93716 40.0696 0.780213 38.6556 0.780213C37.2416 0.780213 36.0914 1.93716 36.0914 3.35938C36.0914 3.57449 35.9174 3.74948 35.7035 3.74948C35.4897 3.74948 35.3157 3.57449 35.3157 3.35938C35.3157 1.50693 36.8139 0 38.6556 0C40.4974 0 41.9956 1.50693 41.9956 3.35938C41.9956 5.21183 40.4974 6.71875 38.6556 6.71875Z"
              fill="#464D5B" />
            <path
              d="M49.2174 10.6722H0.388961C0.175088 10.6722 0.00110815 10.4972 0.00110815 10.2821C0.00110815 10.067 0.175088 9.89199 0.388961 9.89199H49.2185C49.4324 9.89199 49.6064 10.067 49.6064 10.2821C49.6053 10.4972 49.4324 10.6722 49.2174 10.6722Z"
              fill="#464D5B" />
            <path
              d="M51.6121 39.1065H5.59395C5.52524 39.1065 5.45875 39.0887 5.40002 39.0541C5.2881 38.9895 2.64072 37.3767 0.0210549 29.5589C-0.0476505 29.355 0.0620565 29.1332 0.264848 29.0652C0.46764 28.9961 0.688162 29.1064 0.755759 29.3104C3.01196 36.0447 5.27258 37.9964 5.71363 38.3263H51.0692C50.5084 36.6132 48.8296 30.9165 48.8296 24.142C48.8296 23.9269 49.0036 23.7519 49.2174 23.7519C49.4313 23.7519 49.6053 23.9269 49.6053 24.142C49.6053 32.0868 51.9512 38.5158 51.9756 38.5793C52.0199 38.6986 52.0033 38.8335 51.9302 38.9382C51.8582 39.0441 51.7396 39.1065 51.6121 39.1065Z"
              fill="#464D5B" />
            <path
              d="M12.6883 16.0813H8.44854C8.23467 16.0813 8.06069 15.9063 8.06069 15.6912C8.06069 15.4761 8.23467 15.3011 8.44854 15.3011H12.6883C12.9022 15.3011 13.0762 15.4761 13.0762 15.6912C13.0762 15.9063 12.9022 16.0813 12.6883 16.0813Z"
              fill="#464D5B" />
            <path
              d="M21.7874 16.0813H17.5476C17.3337 16.0813 17.1597 15.9063 17.1597 15.6912C17.1597 15.4761 17.3337 15.3011 17.5476 15.3011H21.7874C22.0012 15.3011 22.1752 15.4761 22.1752 15.6912C22.1752 15.9063 22.0023 16.0813 21.7874 16.0813Z"
              fill="#464D5B" />
            <path
              d="M30.8875 16.0813H26.6477C26.4338 16.0813 26.2599 15.9063 26.2599 15.6912C26.2599 15.4761 26.4338 15.3011 26.6477 15.3011H30.8875C31.1014 15.3011 31.2754 15.4761 31.2754 15.6912C31.2754 15.9063 31.1014 16.0813 30.8875 16.0813Z"
              fill="#464D5B" />
            <path
              d="M39.9865 16.0813H35.7467C35.5329 16.0813 35.3589 15.9063 35.3589 15.6912C35.3589 15.4761 35.5329 15.3011 35.7467 15.3011H39.9865C40.2004 15.3011 40.3744 15.4761 40.3744 15.6912C40.3744 15.9063 40.2004 16.0813 39.9865 16.0813Z"
              fill="#464D5B" />
            <path
              d="M12.6883 21.0167H8.44855C8.23467 21.0167 8.06069 20.8417 8.06069 20.6266C8.06069 20.4115 8.23467 20.2365 8.44855 20.2365H12.6883C12.9022 20.2365 13.0762 20.4115 13.0762 20.6266C13.0762 20.8417 12.9022 21.0167 12.6883 21.0167Z"
              fill="#464D5B" />
            <path
              d="M21.7874 21.0167H17.5476C17.3337 21.0167 17.1597 20.8417 17.1597 20.6266C17.1597 20.4115 17.3337 20.2365 17.5476 20.2365H21.7874C22.0012 20.2365 22.1752 20.4115 22.1752 20.6266C22.1752 20.8417 22.0023 21.0167 21.7874 21.0167Z"
              fill="#464D5B" />
            <path
              d="M30.8875 21.0167H26.6477C26.4338 21.0167 26.2599 20.8417 26.2599 20.6266C26.2599 20.4115 26.4338 20.2365 26.6477 20.2365H30.8875C31.1014 20.2365 31.2754 20.4115 31.2754 20.6266C31.2754 20.8417 31.1014 21.0167 30.8875 21.0167Z"
              fill="#464D5B" />
            <path
              d="M39.9865 21.0167H35.7467C35.5329 21.0167 35.3589 20.8417 35.3589 20.6266C35.3589 20.4115 35.5329 20.2365 35.7467 20.2365H39.9865C40.2004 20.2365 40.3744 20.4115 40.3744 20.6266C40.3744 20.8417 40.2004 21.0167 39.9865 21.0167Z"
              fill="#464D5B" />
            <path
              d="M12.6883 25.951H8.44855C8.23467 25.951 8.06069 25.776 8.06069 25.5609C8.06069 25.3458 8.23467 25.1708 8.44855 25.1708H12.6883C12.9022 25.1708 13.0762 25.3458 13.0762 25.5609C13.0762 25.776 12.9022 25.951 12.6883 25.951Z"
              fill="#464D5B" />
            <path
              d="M21.7874 25.951H17.5476C17.3337 25.951 17.1597 25.776 17.1597 25.5609C17.1597 25.3458 17.3337 25.1708 17.5476 25.1708H21.7874C22.0012 25.1708 22.1752 25.3458 22.1752 25.5609C22.1752 25.776 22.0023 25.951 21.7874 25.951Z"
              fill="#464D5B" />
            <path
              d="M30.8875 25.951H26.6477C26.4338 25.951 26.2599 25.776 26.2599 25.5609C26.2599 25.3458 26.4338 25.1708 26.6477 25.1708H30.8875C31.1014 25.1708 31.2754 25.3458 31.2754 25.5609C31.2754 25.776 31.1014 25.951 30.8875 25.951Z"
              fill="#464D5B" />
            <path
              d="M39.9865 25.951H35.7467C35.5329 25.951 35.3589 25.776 35.3589 25.5609C35.3589 25.3458 35.5329 25.1708 35.7467 25.1708H39.9865C40.2004 25.1708 40.3744 25.3458 40.3744 25.5609C40.3744 25.776 40.2004 25.951 39.9865 25.951Z"
              fill="#464D5B" />
            <path
              d="M12.6883 30.8853H8.44855C8.23467 30.8853 8.06069 30.7103 8.06069 30.4952C8.06069 30.2801 8.23467 30.1051 8.44855 30.1051H12.6883C12.9022 30.1051 13.0762 30.2801 13.0762 30.4952C13.0762 30.7103 12.9022 30.8853 12.6883 30.8853Z"
              fill="#464D5B" />
            <path
              d="M21.7874 30.8853H17.5476C17.3337 30.8853 17.1597 30.7103 17.1597 30.4952C17.1597 30.2801 17.3337 30.1051 17.5476 30.1051H21.7874C22.0012 30.1051 22.1752 30.2801 22.1752 30.4952C22.1752 30.7103 22.0023 30.8853 21.7874 30.8853Z"
              fill="#464D5B" />
            <path
              d="M30.8875 30.8853H26.6477C26.4338 30.8853 26.2599 30.7103 26.2599 30.4952C26.2599 30.2801 26.4338 30.1051 26.6477 30.1051H30.8875C31.1014 30.1051 31.2754 30.2801 31.2754 30.4952C31.2754 30.7103 31.1014 30.8853 30.8875 30.8853Z"
              fill="#464D5B" />
            <path
              d="M39.9865 30.8853H35.7467C35.5329 30.8853 35.3589 30.7103 35.3589 30.4952C35.3589 30.2801 35.5329 30.1051 35.7467 30.1051H39.9865C40.2004 30.1051 40.3744 30.2801 40.3744 30.4952C40.3744 30.7103 40.2004 30.8853 39.9865 30.8853Z"
              fill="#464D5B" />
          </svg>
          <h1 class="main-text">CALENDARIO</h1>
          <p class="sub-text">semanal</p>
          <div class="button-micro ">
            <specialButtonMicro class="mobile" />
          </div>
        </div>
      </div>
      <div class="cards-container">
        <div class="card desktop" @click="linkTo('clases')">
          <div class="title-container">
            <svg class="left-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16"
              fill="none">
              <path
                d="M6.5 0.500122C7.34615 0.500122 7.76923 1.11531 7.76923 2.34567C7.76923 2.89541 7.71795 3.53677 7.61539 4.26976L7.46154 5.2907C7.41026 5.73572 7.3718 6.01059 7.34615 6.11531L7.26923 6.62578L9.11539 5.13363C10.3205 4.13886 11.1923 3.64148 11.7308 3.64148C12.2692 3.64148 12.641 3.85091 12.8462 4.26976C12.9487 4.42682 13 4.61007 13 4.81949C13 5.39541 12.7051 5.86662 12.1154 6.23311C11.5513 6.57342 10.7821 6.92682 9.80769 7.29331L8.07692 8.00012L10.2308 8.864C11 9.17813 11.5641 9.453 11.9231 9.6886C12.641 10.0813 13 10.5787 13 11.1808C13 11.364 12.9103 11.6127 12.7308 11.9268C12.5769 12.2148 12.2436 12.3588 11.7308 12.3588C11.2179 12.3588 10.3462 11.8614 9.11539 10.8666L7.26923 9.37447L7.34615 9.96347C7.34615 10.0944 7.38462 10.3561 7.46154 10.7488L7.69231 12.1232C7.74359 12.6467 7.76923 13.1703 7.76923 13.6938C7.76923 14.1912 7.65385 14.6232 7.42308 14.9897C7.21795 15.33 6.91026 15.5001 6.5 15.5001C6.08974 15.5001 5.76923 15.33 5.53846 14.9897C5.33333 14.6232 5.23077 14.1781 5.23077 13.6546C5.23077 13.1048 5.28205 12.4635 5.38462 11.7305L5.53846 10.7095C5.58974 10.2645 5.6282 9.98965 5.65385 9.88494L5.73077 9.37447L3.88462 10.8666C2.67949 11.8614 1.80769 12.3588 1.26923 12.3588C0.730769 12.3588 0.358974 12.1493 0.153846 11.7305C0.0512821 11.5734 0 11.3902 0 11.1808C0 10.6048 0.282051 10.1467 0.846154 9.8064C1.4359 9.43991 2.21795 9.07342 3.19231 8.70693L4.92308 8.00012L2.76923 7.13625C2.02564 6.84829 1.44872 6.57342 1.03846 6.31164C0.346154 5.89279 0 5.39541 0 4.81949C0 4.63625 0.0769231 4.40065 0.230769 4.11269C0.410256 3.79855 0.692308 3.64148 1.07692 3.64148C1.48718 3.64148 1.89744 3.77237 2.30769 4.03415C2.71795 4.26975 3.24359 4.63625 3.88462 5.13363L5.73077 6.62578L5.65385 6.03677C5.65385 5.90588 5.61539 5.6441 5.53846 5.25143L5.30769 3.87709C5.25641 3.35353 5.23077 2.82996 5.23077 2.3064C5.23077 1.75667 5.33333 1.32473 5.53846 1.01059C5.76923 0.670279 6.08974 0.500122 6.5 0.500122Z"
                fill="url(#paint0_linear_1404_3761)" />
              <defs>
                <linearGradient id="paint0_linear_1404_3761" x1="13" y1="8.00012" x2="0" y2="8.00012"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FFE711" />
                  <stop offset="1" stop-color="#96FF11" />
                </linearGradient>
              </defs>
            </svg>
            <h3 class="card-title">Clases</h3>
            <svg class="right-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="28" viewBox="0 0 33 28"
              fill="none">
              <path
                d="M11.6947 20.0502V15.2223C11.6947 14.9852 11.5794 14.7541 11.3732 14.5838L10.9123 14.2008C10.7061 14.0305 10.5908 13.7995 10.5908 13.5623V8.89863M10.5908 7.00761H7.80098V9.87758H10.5908M23.2604 9.87758H25.2801V7.00761H21.3318M19.6882 20.0502V15.3743C19.6882 15.052 19.9065 14.7602 20.2522 14.6142L22.5508 13.6657C23.0482 13.4407 23.3575 12.9968 23.3393 12.5287L23.2544 9.92014C23.2362 9.44587 22.9026 9.01415 22.381 8.8135L20.4281 8.05344C19.7246 7.77982 18.8876 8.02304 18.5419 8.60068C18.1902 9.18441 18.4813 9.89582 19.1909 10.1877L20.6343 10.7775C20.6343 10.7775 16.4859 11.0389 16.5344 14.3163M5.56909 15.7999C4.33791 15.7999 3.3372 14.7967 3.3372 13.5623V3.23773C3.3372 2.0034 4.33791 1.00012 5.56909 1.00012C6.80027 1.00012 7.80098 2.0034 7.80098 3.23773V13.5623C7.80098 14.7967 6.80027 15.7999 5.56909 15.7999ZM27.5119 1.00012C28.7431 1.00012 29.7438 2.0034 29.7438 3.23773V13.5623C29.7438 14.7967 28.7431 15.7999 27.5119 15.7999C26.2808 15.7999 25.2801 14.7967 25.2801 13.5623V3.23773C25.2801 2.0034 26.2808 1.00012 27.5119 1.00012ZM3.3372 3.24381H2.16667C1.56625 3.24381 1.08105 3.64512 1.08105 4.13763V12.7476C1.08105 13.2461 1.56625 13.6475 2.16667 13.6475H3.3372V3.24381ZM30.9144 3.24381H29.7438V13.6475H30.9144C31.5148 13.6475 32 13.2461 32 12.7476V4.13763C32 3.64512 31.5148 3.24381 30.9144 3.24381ZM14.6179 10.3823C15.3579 10.3823 15.9583 9.88366 15.9583 9.26953V4.74568C15.9583 4.12547 15.3336 3.63296 14.5755 3.65728C13.8477 3.6816 13.2715 4.1802 13.2715 4.78216V9.26953C13.2776 9.88974 13.878 10.3823 14.6179 10.3823ZM11.9372 10.0053C12.6772 10.0053 13.2776 9.50667 13.2776 8.89255V4.99498C13.2776 4.37477 12.6529 3.88226 11.8948 3.90658C11.167 3.9309 10.5908 4.4295 10.5908 5.03146V8.89255C10.5908 9.51275 11.1913 10.0053 11.9372 10.0053ZM18.5601 9.66476C18.3539 9.3425 18.3357 8.94727 18.5419 8.5946C18.5723 8.54596 18.6087 8.49732 18.645 8.45475V4.62407C18.645 4.00386 18.0204 3.51135 17.2622 3.53567C16.5345 3.55999 15.9583 4.05859 15.9583 4.66055V9.27561C15.9583 9.88974 16.5587 10.3883 17.2986 10.3883C17.8809 10.3823 18.3721 10.0843 18.5601 9.66476ZM20.4342 8.04736L21.3318 8.40003V5.48749C21.3318 4.86729 20.7071 4.37477 19.949 4.39909C19.2212 4.42342 18.645 4.92201 18.645 5.52398V8.44867C19.0332 7.9744 19.7913 7.79806 20.4342 8.04736ZM21.1377 27.0001V23.8505C21.1377 21.7466 19.4395 20.0441 17.3411 20.0441H14.0357C11.9372 20.0441 10.2391 21.7466 10.2391 23.8505V27.0001H21.1377Z"
                stroke="url(#paint0_linear_1581_8235)" stroke-width="2" stroke-miterlimit="10"
                stroke-linejoin="round" />
              <defs>
                <linearGradient id="paint0_linear_1581_8235" x1="1.08105" y1="14.0001" x2="32" y2="14.0001"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.23516" stop-color="#4536EF" />
                  <stop offset="0.913242" stop-color="#FF00B8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <p class="card-text">
            Explora clases dinámicas y efectivas para llevar tu entrenamiento al siguiente nivel. Aprende y progresa
            desde cualquier lugar
          </p>
        </div>
        <div class="card desktop" @click="linkTo('recetas')">
          <div class="title-container">
            <svg class="left-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16"
              fill="none">
              <path
                d="M6.5 0.500122C7.34615 0.500122 7.76923 1.11531 7.76923 2.34567C7.76923 2.89541 7.71795 3.53677 7.61539 4.26976L7.46154 5.2907C7.41026 5.73572 7.3718 6.01059 7.34615 6.11531L7.26923 6.62578L9.11539 5.13363C10.3205 4.13886 11.1923 3.64148 11.7308 3.64148C12.2692 3.64148 12.641 3.85091 12.8462 4.26976C12.9487 4.42682 13 4.61007 13 4.81949C13 5.39541 12.7051 5.86662 12.1154 6.23311C11.5513 6.57342 10.7821 6.92682 9.80769 7.29331L8.07692 8.00012L10.2308 8.864C11 9.17813 11.5641 9.453 11.9231 9.6886C12.641 10.0813 13 10.5787 13 11.1808C13 11.364 12.9103 11.6127 12.7308 11.9268C12.5769 12.2148 12.2436 12.3588 11.7308 12.3588C11.2179 12.3588 10.3462 11.8614 9.11539 10.8666L7.26923 9.37447L7.34615 9.96347C7.34615 10.0944 7.38462 10.3561 7.46154 10.7488L7.69231 12.1232C7.74359 12.6467 7.76923 13.1703 7.76923 13.6938C7.76923 14.1912 7.65385 14.6232 7.42308 14.9897C7.21795 15.33 6.91026 15.5001 6.5 15.5001C6.08974 15.5001 5.76923 15.33 5.53846 14.9897C5.33333 14.6232 5.23077 14.1781 5.23077 13.6546C5.23077 13.1048 5.28205 12.4635 5.38462 11.7305L5.53846 10.7095C5.58974 10.2645 5.6282 9.98965 5.65385 9.88494L5.73077 9.37447L3.88462 10.8666C2.67949 11.8614 1.80769 12.3588 1.26923 12.3588C0.730769 12.3588 0.358974 12.1493 0.153846 11.7305C0.0512821 11.5734 0 11.3902 0 11.1808C0 10.6048 0.282051 10.1467 0.846154 9.8064C1.4359 9.43991 2.21795 9.07342 3.19231 8.70693L4.92308 8.00012L2.76923 7.13625C2.02564 6.84829 1.44872 6.57342 1.03846 6.31164C0.346154 5.89279 0 5.39541 0 4.81949C0 4.63625 0.0769231 4.40065 0.230769 4.11269C0.410256 3.79855 0.692308 3.64148 1.07692 3.64148C1.48718 3.64148 1.89744 3.77237 2.30769 4.03415C2.71795 4.26975 3.24359 4.63625 3.88462 5.13363L5.73077 6.62578L5.65385 6.03677C5.65385 5.90588 5.61539 5.6441 5.53846 5.25143L5.30769 3.87709C5.25641 3.35353 5.23077 2.82996 5.23077 2.3064C5.23077 1.75667 5.33333 1.32473 5.53846 1.01059C5.76923 0.670279 6.08974 0.500122 6.5 0.500122Z"
                fill="url(#paint0_linear_1404_3761)" />
              <defs>
                <linearGradient id="paint0_linear_1404_3761" x1="13" y1="8.00012" x2="0" y2="8.00012"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FFE711" />
                  <stop offset="1" stop-color="#96FF11" />
                </linearGradient>
              </defs>
            </svg>
            <h3 class="card-title">Recetas</h3>
            <svg class="right-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="27" viewBox="0 0 33 27"
              fill="none">
              <path
                d="M21.4367 18.466L23.9681 15.9427C25.4857 14.4299 27.951 14.4299 29.4687 15.9427L32 18.466L29.4687 20.9894C28.3529 22.1015 26.7214 22.4005 25.3357 21.8743M11.5633 18.466L9.03193 15.9427C7.51432 14.4299 5.05495 14.4299 3.53135 15.9427L1 18.466L3.53135 20.9894C4.64706 22.1015 6.27864 22.4005 7.66428 21.8743M11.0174 7.32636C12.1151 9.20988 14.1606 10.4715 16.506 10.4715C18.8454 10.4715 20.8909 9.20988 21.9946 7.32636M16.5 10.4715V13.3895M13.0809 9.47297L11.3053 11.6674M19.9251 9.47297L21.7007 11.6674M21.6467 1.00012C19.6012 1.00012 17.7657 1.89106 16.5 3.3022C15.2343 1.89106 13.3988 1.00012 11.3533 1.00012C7.54431 1.00012 4.45511 4.07953 4.45511 7.87647C4.45511 9.5806 5.00697 11.1173 6.19466 12.7258C8.63603 16.0264 14.5325 21.1388 16.494 22.8011C18.4555 21.1388 24.352 16.0205 26.7933 12.7258C27.981 11.1173 28.5329 9.58658 28.5329 7.87647C28.5449 4.07953 25.4557 1.00012 21.6467 1.00012ZM22.4385 19.4048H24.376C25.6656 20.6904 25.6656 22.7772 24.376 24.0688L22.4385 26.0001L20.501 24.0688C19.2113 22.7832 19.2113 20.6964 20.501 19.4048H22.4385ZM10.5675 17.4735L8.63003 19.4048C7.34036 20.6904 7.34036 22.7772 8.63003 24.0688L10.5675 26.0001L12.505 24.0688C13.7947 22.7832 13.7947 20.6964 12.505 19.4048L10.5675 17.4735Z"
                stroke="url(#paint0_linear_1404_3750)" stroke-width="2" stroke-miterlimit="10"
                stroke-linejoin="round" />
              <defs>
                <linearGradient id="paint0_linear_1404_3750" x1="1" y1="13.5001" x2="32" y2="13.5001"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.23516" stop-color="#4536EF" />
                  <stop offset="0.913242" stop-color="#FF00B8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <p class="card-text">
            Descubre recetas saludables y deliciosas diseñadas por nuestras nutriólogas para complementar tu estilo de
            vida.

          </p>
        </div>
        <div class="card desktop" @click="linkTo('comunidad')">
          <div class="title-container">
            <svg class="left-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16"
              fill="none">
              <path
                d="M6.5 0.500122C7.34615 0.500122 7.76923 1.11531 7.76923 2.34567C7.76923 2.89541 7.71795 3.53677 7.61539 4.26976L7.46154 5.2907C7.41026 5.73572 7.3718 6.01059 7.34615 6.11531L7.26923 6.62578L9.11539 5.13363C10.3205 4.13886 11.1923 3.64148 11.7308 3.64148C12.2692 3.64148 12.641 3.85091 12.8462 4.26976C12.9487 4.42682 13 4.61007 13 4.81949C13 5.39541 12.7051 5.86662 12.1154 6.23311C11.5513 6.57342 10.7821 6.92682 9.80769 7.29331L8.07692 8.00012L10.2308 8.864C11 9.17813 11.5641 9.453 11.9231 9.6886C12.641 10.0813 13 10.5787 13 11.1808C13 11.364 12.9103 11.6127 12.7308 11.9268C12.5769 12.2148 12.2436 12.3588 11.7308 12.3588C11.2179 12.3588 10.3462 11.8614 9.11539 10.8666L7.26923 9.37447L7.34615 9.96347C7.34615 10.0944 7.38462 10.3561 7.46154 10.7488L7.69231 12.1232C7.74359 12.6467 7.76923 13.1703 7.76923 13.6938C7.76923 14.1912 7.65385 14.6232 7.42308 14.9897C7.21795 15.33 6.91026 15.5001 6.5 15.5001C6.08974 15.5001 5.76923 15.33 5.53846 14.9897C5.33333 14.6232 5.23077 14.1781 5.23077 13.6546C5.23077 13.1048 5.28205 12.4635 5.38462 11.7305L5.53846 10.7095C5.58974 10.2645 5.6282 9.98965 5.65385 9.88494L5.73077 9.37447L3.88462 10.8666C2.67949 11.8614 1.80769 12.3588 1.26923 12.3588C0.730769 12.3588 0.358974 12.1493 0.153846 11.7305C0.0512821 11.5734 0 11.3902 0 11.1808C0 10.6048 0.282051 10.1467 0.846154 9.8064C1.4359 9.43991 2.21795 9.07342 3.19231 8.70693L4.92308 8.00012L2.76923 7.13625C2.02564 6.84829 1.44872 6.57342 1.03846 6.31164C0.346154 5.89279 0 5.39541 0 4.81949C0 4.63625 0.0769231 4.40065 0.230769 4.11269C0.410256 3.79855 0.692308 3.64148 1.07692 3.64148C1.48718 3.64148 1.89744 3.77237 2.30769 4.03415C2.71795 4.26975 3.24359 4.63625 3.88462 5.13363L5.73077 6.62578L5.65385 6.03677C5.65385 5.90588 5.61539 5.6441 5.53846 5.25143L5.30769 3.87709C5.25641 3.35353 5.23077 2.82996 5.23077 2.3064C5.23077 1.75667 5.33333 1.32473 5.53846 1.01059C5.76923 0.670279 6.08974 0.500122 6.5 0.500122Z"
                fill="url(#paint0_linear_1404_3761)" />
              <defs>
                <linearGradient id="paint0_linear_1404_3761" x1="13" y1="8.00012" x2="0" y2="8.00012"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FFE711" />
                  <stop offset="1" stop-color="#96FF11" />
                </linearGradient>
              </defs>
            </svg>
            <h3 class="card-title">Comunidad</h3>
            <svg class="right-icon" xmlns="http://www.w3.org/2000/svg" width="31" height="26" viewBox="0 0 31 26"
              fill="none">
              <g clip-path="url(#clip0_1404_3780)">
                <path
                  d="M15.9588 9.34601C15.9588 9.34601 14.0751 7.24006 14.0751 4.64461C14.0751 2.04916 15.9588 0.284714 15.9588 0.284714C15.9588 0.284714 17.8425 2.04916 17.8425 4.64461C17.8425 7.24006 15.9588 9.34601 15.9588 9.34601ZM15.9588 9.34601C21.6157 9.34601 22.5575 3.84776 22.626 2.69802C22.626 2.69802 19.8005 2.85739 17.9624 4.69014C17.9224 4.72998 17.8825 4.76983 17.8425 4.80967M15.9588 9.34601C10.3019 9.34601 9.36008 3.84776 9.29159 2.69802C9.29159 2.69802 12.1172 2.85739 13.9552 4.69014C13.9952 4.72998 14.0351 4.76983 14.0751 4.80967M13.2816 16.8648H17.8425C18.8814 16.8648 19.7263 16.0225 19.7263 14.9866C19.7263 13.9507 18.8814 13.1083 17.8425 13.1083H11.2609C9.42858 13.1083 7.65332 13.7742 6.27763 14.9809L1.18018 19.4603L6.51167 25.7155L12.1857 20.6214H21.6157L30.7146 11.6113C29.2419 10.1429 26.7931 10.1429 25.3203 11.6113L20.0516 16.8648H13.1275"
                  stroke="url(#paint0_linear_1404_3780)" stroke-width="2" stroke-miterlimit="10"
                  stroke-linejoin="round" />
              </g>
              <defs>
                <linearGradient id="paint0_linear_1404_3780" x1="1.18018" y1="13.0001" x2="30.7146" y2="13.0001"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.23516" stop-color="#4536EF" />
                  <stop offset="0.913242" stop-color="#FF00B8" />
                </linearGradient>
                <clipPath id="clip0_1404_3780">
                  <rect width="30.1053" height="26" fill="white" transform="translate(0.894775 0.00012207)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <p class="card-text">
            Conéctate con usuarios que comparten tus objetivos. Inspírate y comparte tu progreso en un espacio positivo.
          </p>
        </div>
        <div class="mobile submenu">
          <subMenu />
        </div>
      </div>
    </div>
    <programas class="desktop" />
    <programasMobile class="mobile" />
  </section>
</template>

<script>
import programas from "../home/programas.vue";
import subMenu from "../subMenu.vue";
import specialButtonMini from "../specialButtonMini.vue";
import specialButtonMicro from "../specialButtonMicro.vue";
import specialButton from "../specialButton.vue";
import programasMobile from "../home/programasMobile.vue";
export default {
  components: {
    specialButtonMini,
    specialButton,
    programas,
    subMenu,
    specialButtonMicro,
    programasMobile,
  },
  data() {
    return {};
  },
  methods: {
    linkTo(enlace) {
      const query = enlace;
      if (query) {
        const currentQuery = this.$route.query.a;

        // Verifica si la búsqueda actual es la misma que la nueva búsqueda
        if (query !== currentQuery) {
          this.$router.push({ path: "/web-app", query: { a: query } });
        } else {
          console.log("Ya te encuentras en este enlace");
        }
      } else {
        console.log("No se recibio link");
      }
    },
  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.mobile {
  display: none;
}

section {
  padding: 0 !important;
}

aside {
  width: 100%;
  height: 30vw;
  display: flex;
  flex-direction: row;
  gap: 1.111111vw;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

aside::-webkit-scrollbar {
  display: none;
}

ul::-webkit-scrollbar {
  display: none;
}

aside>div {
  scroll-snap-align: center;
}

.cardMain {
  min-width: 29.097222vw;
  height: 100%;
  border-radius: 2.083333vw;
  padding: 1.388889vw 1.388889vw;
  position: relative;
  border-radius: 2.083333vw;
  overflow: hidden;
}

.cardMainContent {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 7.361111vw;
  height: 100%;
}

.miniBadge p {
  color: var(--white, #fff);
  text-align: center;
  font-family: Manrope;
  font-size: 1.388889vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.388889vw;
}

.miniBadge {
  display: inline-flex;
  width: fit-content;
  padding: 1.041667vw 2.083333vw;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.083333vw;
  border: 0.069444vw solid var(--white, #fff);
  border-radius: 2.083333vw;
}

.miniBadgeBlack p {
  color: #464d5b;
  text-align: center;
  font-family: Manrope;
  font-size: 1.388889vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.388889vw;
}

.miniBadgeBlack {
  display: inline-flex;
  width: fit-content;
  padding: 1.041667vw 2.083333vw;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.083333vw;
  border: 0.069444vw solid #464d5b;
  border-radius: 2.083333vw;
}

.cardMainInfo {
  display: flex;
  flex-direction: column;
  gap: 0.694444vw;
}

.cardMainInfo h5 {
  color: var(--white, #fff);
  font-family: Manrope;
  font-size: 2.777778vw;
  font-style: normal;
  font-weight: 400;
  line-height: 2.777778vw;
}

.cardMainInfo p {
  color: var(--white, #fff);
  font-family: Manrope;
  font-size: 1.041667vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.041667vw;
}

.botR {
  position: absolute;
  right: 0.208333vw;
  bottom: 0.486111vw;
  z-index: 2;
}

.cardInfo {
  min-width: 23.125vw;
  height: 100%;
  background-color: #e3e3e9;
  border-radius: 2.083333vw;
  padding: 1.388889vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.388889vw;
}

.cardInfoInfo {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.694444vw;
}

.cardInfoInfo h6 {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 2.777778vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.cardInfoInfo p {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.041667vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 100%;
  height: fill;
}

.programaCont {
  display: flex;
  flex-direction: row;
  gap: 1.111111vw;
}

.textBox {
  display: none;
}

.coverImage {
  display: none;
}

.main-container {
  display: flex;
  gap: 2.0833vw;
  align-items: flex-start;
  justify-content: space-between;
}

.image-container {
  position: relative;
  width: 80%;
  height: 27.5vw;
  border-radius: 2.0833vw;
  overflow: hidden;
  cursor: pointer;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 38%;
}

.text-overlay {
  position: absolute;
  padding-top: 17.1528vw;
  right: 1.6667vw;
  text-align: right;
}

.main-text {
  font-family: Kemio, sans-serif;
  font-size: 5.5556vw;
  font-weight: 400;
  line-height: 139.195%;
  text-transform: uppercase;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.sub-text {
  position: relative;
  font-family: Manrope, sans-serif;
  font-size: 2.4306vw;
  font-weight: 400;
  line-height: 135.815%;
  color: var(--Text, #ffffff);
  top: -1.3889vw;
}

.cards-container {
  display: flex;
  flex-direction: column;
  gap: 1.0417vw;
  width: 30%;
  align-self: stretch;
}

.card:hover {
  box-shadow: 0 0.2778vw 0.6944vw rgba(0, 0, 0, 0.3);
}

.card {
  display: flex;
  cursor: pointer;
  position: relative;
  padding: 1.3889vw;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.0417vw;
  align-self: stretch;
  border-radius: 2.0833vw;
  transition: all 0.5s ease;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background-color: #fff;
}


.title-container {
  display: flex;
  align-items: center;
  gap: 1.0417vw;
  width: 100%;
}

.card-title {
  flex: 1 0 0;
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 1.3889vw;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card-text {
  align-self: stretch;
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 0.8333vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.right-icon {
  padding-left: 1.3889vw;
  width: auto;
  height: 2.0833vw;
}

.left-icon {
  width: auto;
  height: 1.3889vw;
}

.button-micro {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.image-clip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@media (max-width: 530px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .submenu {
    width: 100%;
    padding-top: 2.3256vw;
  }

  .main-container {
    padding-top: 6vh;

    flex-direction: column;
    gap: 1.0417vw;
    margin-bottom: 15px;
  }

  .image-container {
    width: 100%;
    height: 50.5vw;
    padding-top: 2.2222vw;
    border-radius: 5.3889vw;
    padding-bottom: 2.3256vw;

  }

  .image-container img {
    object-fit: cover;
  }

  .text-overlay {
    padding-top: 0;
    padding-left: 1.0417vw;
    padding-right: 1.0417vw;
    top: 12.663vw;
    left: 2.3256vw;
    text-align: left;
  }

  .image-clip {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    clip-path: polygon(4.988% 0%, 95.012% 0%, 95.012% 0%, 95.821% 0.112%, 96.589% 0.436%, 97.305% 0.954%, 97.958% 1.649%, 98.539% 2.503%, 99.038% 3.499%, 99.443% 4.619%, 99.746% 5.845%, 99.935% 7.161%, 100% 8.547%, 100% 71.81%, 100% 71.81%, 99.935% 73.197%, 99.746% 74.512%, 99.443% 75.738%, 99.038% 76.858%, 98.539% 77.854%, 97.958% 78.708%, 97.305% 79.403%, 96.589% 79.922%, 95.821% 80.245%, 95.012% 80.357%, 92.748% 80.357%, 92.748% 80.357%, 91.939% 80.469%, 91.172% 80.793%, 90.456% 81.311%, 89.802% 82.006%, 89.221% 82.861%, 88.723% 83.856%, 88.317% 84.976%, 88.015% 86.203%, 87.826% 87.518%, 87.76% 88.904%, 87.76% 91.453%, 87.76% 91.453%, 87.695% 92.839%, 87.506% 94.155%, 87.204% 95.381%, 86.798% 96.501%, 86.3% 97.497%, 85.718% 98.351%, 85.065% 99.046%, 84.349% 99.564%, 83.582% 99.888%, 82.773% 100%, 4.988% 100%, 4.988% 100%, 4.179% 99.888%, 3.411% 99.564%, 2.695% 99.046%, 2.042% 98.351%, 1.461% 97.497%, 0.962% 96.501%, 0.557% 95.381%, 0.254% 94.155%, 0.065% 92.839%, 0% 91.453%, 0% 8.547%, 0% 8.547%, 0.065% 7.161%, 0.254% 5.845%, 0.557% 4.619%, 0.962% 3.499%, 1.461% 2.503%, 2.042% 1.649%, 2.695% 0.954%, 3.411% 0.436%, 4.179% 0.112%, 4.988% 0%);
  }

  .main-text {
    font-size: 15.1163vw;
  }

  .calendar-svg {
    position: absolute;
    top: -9.3023vw;
    left: 1.8605vw;
  }

  .sub-text {
    font-size: 5.4306vw;
  }

  .button-micro {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    z-index: 2;
  }

  .cards-container {
    width: 100%;
  }

  .card {
    padding: 1.0417vw;
  }

  .card-title {
    font-size: 1.1111vw;
  }

  .card-text {
    font-size: 0.6944vw;
  }

  .right-icon {
    height: 1.6667vw;
  }

  .left-icon {
    height: 1.1111vw;
  }
}
</style>
